import { combineReducers } from '@reduxjs/toolkit';
import { hydrateReducer } from '@doda/common/src/redux/utils/hydrateReducer';
import {
  memberInfoReducer,
  memberInfoInitialState,
} from '@doda/common/src/redux/features/memberInfo';
import {
  analyticsReducer,
  analyticsInitialState,
} from '@doda/common/src/redux/features/analytics';
import {
  masterInitialState,
  masterReducer,
} from '@doda/common/src/redux/features/master';
import {
  abTestReducer,
  abTestInitialState,
} from '@doda/common/src/redux/features/abTest';
import {
  jobCountInitialState,
  jobCountReducer,
} from '@doda/common/src/redux/features/jobCount';
import {
  queryParamsInitialState,
  queryParamsReducer,
} from '@doda/common/src/redux/features/queryParams';
import {
  intentionJobListInitialState,
  intentionJobListReducer,
} from '@doda/common/src/redux/features/intentionJobList';
import {
  canonicalInitialState,
  canonicalReducer,
} from '@doda/common/src/redux/features/canonical';
import {
  savedSearchesInitialState,
  savedSearchesReducer,
} from '@doda/common/src/redux/features/savedSearches';
import {
  searchLabelInitialState,
  searchLabelReducer,
} from '@doda/common/src/redux/features/searchConditionLabel';
import {
  seoTextInitialState,
  seoTextReducer,
} from '@doda/common/src/redux/features/seoText';
import {
  plpLinkListDataIndexReducer,
  seoPlpLinkListDataIndexInitialState,
} from '@doda/common/src/redux/features/plpLinkList';
import {
  prefOnlySelectInitialState,
  prefOnlySelectReducer,
} from '@doda/common/src/redux/features/prefOnlyFlgSlice';
import {
  jobContentLinkInitialState,
  jobContentLinkReducer,
} from '@doda/common/src/redux/features/JobContent/jobContentLink';
import {
  jobTrendRankingInitialState,
  jobTrendRankingReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRanking';
import {
  jobTrendRecommendListInitialState,
  jobTrendRecommendListReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRecommendList';
import {
  jobRecommendOffsetInitialState,
  jobRecommendOffsetReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendOffset';
import {
  jobRecommendListForTrendRequirementsInitialState,
  jobRecommendListForTrendRequirementsReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendRequirements';
import {
  jobRecommendListForTrendIncomeInitialState,
  jobRecommendListForTrendIncomeReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendIncome';
import {
  jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  jobRecommendListForTrendWorkplaceEnvironmentsReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendWorkplaceEnvironment1';
import {
  jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendHolidayAndWayOfWorking';
import {
  jobRecommendListForTrendEmployeeAverageAgeInitialState,
  jobRecommendListForTrendEmployeeAverageAgeReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEmployeeAverageAge';
import {
  jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendEmploymentStatusState,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEmploymentStatus';
import {
  jobRecommendListForTrendWelfareBenefitsInitialState,
  jobRecommendListForTrendWelfareBenefitsReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendWelfareBenefits';
import {
  jobRecommendListForTrendLanguageAndPositionsInitialState,
  jobRecommendListForTrendLanguageAndPositionsReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendLanguageAndPositions';
import {
  jobRecommendListForTrendEstablishInitialState,
  jobRecommendListForTrendEstablishReducer,
} from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendListForTrendEstablish';
import {
  precounselingInitialState,
  precounselingReducer,
} from '@doda/common/src/redux/features/precounseling';
import { mergeReducer } from '@doda/common/src/redux/utils/mergeReducer';
import {
  bookmarkReducer as bookmarkReducerCommon,
  bookmarkSliceInitialState as bookmarkSliceInitialStateCommon,
} from '@doda/common/src/redux/features/referredJobDetail/slices/bookmark';
import {
  resourceUrlInitialState,
  resourceUrlReducer,
} from './features/resourceUrl';
import {
  jobSearchDetailInitialState,
  jobSearchDetailReducer,
} from '../pages/DodaFront/View/JobSearchDetail/redux/features/jobSearchDetail';
import {
  bookmarkInitialState as bookmarkInitialStatePC,
  bookmarkReducer as bookmarkReducerPC,
} from '../pages/DodaFront/View/JobSearchDetail/redux/slices/bookmark';
import {
  careerRecommendJobListInitialState,
  careerRecommendJobListReducer,
} from './features/careerRecommendJobList';
import {
  initialState as jobListInitialState,
  jobListReducer,
} from './features/jobList';
import {
  rewritesUrlInitialState,
  rewritesUrlReducer,
} from './features/rewritesUrl';
import {
  uiInitialState,
  uiReducer,
} from '../pages/dcfront/referredJob/referredJobDetail/redux/uiSlice';

const reducers = combineReducers({
  memberInfo: memberInfoReducer,
  master: masterReducer,
  analytics: analyticsReducer,
  abTest: abTestReducer,
  jobCount: jobCountReducer,
  queryParams: queryParamsReducer,
  intentionJobList: intentionJobListReducer,
  rewritesUrl: rewritesUrlReducer,
  canonical: canonicalReducer,
  jobList: jobListReducer,
  savedSearches: savedSearchesReducer,
  searchLabel: searchLabelReducer,
  seoText: seoTextReducer,
  careerRecommendJobList: careerRecommendJobListReducer,
  plpLinkList: plpLinkListDataIndexReducer,
  prefOnlyFlg: prefOnlySelectReducer,
  jobContentLink: jobContentLinkReducer,
  // 紹介求人詳細は common 配下の slice を、他は pc 配下の slice を使っているため
  // TODO: 使ってる slice を統一させる
  bookmark: mergeReducer(bookmarkReducerPC, bookmarkReducerCommon),
  jobSearchDetail: jobSearchDetailReducer,
  resourceUrl: resourceUrlReducer,
  jobTrendRanking: jobTrendRankingReducer,
  jobTrendRecommendList: jobTrendRecommendListReducer,
  jobRecommendOffset: jobRecommendOffsetReducer,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsReducer,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeReducer,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentsReducer,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingReducer,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeReducer,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusReducer,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsReducer,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsReducer,
  jobRecommendListForTrendEstablish: jobRecommendListForTrendEstablishReducer,
  precounseling: precounselingReducer,
  ui: uiReducer,
});

const initialState = {
  memberInfo: memberInfoInitialState,
  master: masterInitialState,
  analytics: analyticsInitialState,
  abTest: abTestInitialState,
  jobCount: jobCountInitialState,
  queryParams: queryParamsInitialState,
  intentionJobList: intentionJobListInitialState,
  rewritesUrl: rewritesUrlInitialState,
  canonical: canonicalInitialState,
  jobList: jobListInitialState,
  savedSearches: savedSearchesInitialState,
  searchLabel: searchLabelInitialState,
  seoText: seoTextInitialState,
  careerRecommendJobList: careerRecommendJobListInitialState,
  plpLinkList: seoPlpLinkListDataIndexInitialState,
  prefOnlyFlg: prefOnlySelectInitialState,
  jobContentLink: jobContentLinkInitialState,
  bookmark: { ...bookmarkInitialStatePC, ...bookmarkSliceInitialStateCommon },
  jobSearchDetail: jobSearchDetailInitialState,
  resourceUrl: resourceUrlInitialState,
  jobTrendRanking: jobTrendRankingInitialState,
  jobTrendRecommendList: jobTrendRecommendListInitialState,
  jobRecommendOffset: jobRecommendOffsetInitialState,
  jobRecommendListForTrendRequirements:
    jobRecommendListForTrendRequirementsInitialState,
  jobRecommendListForTrendIncome: jobRecommendListForTrendIncomeInitialState,
  jobRecommendListForTrendWorkplaceEnvironment:
    jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  jobRecommendListForTrendHolidayAndWayOfWorking:
    jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  jobRecommendListForTrendEmployeeAverageAge:
    jobRecommendListForTrendEmployeeAverageAgeInitialState,
  jobRecommendListForTrendEmploymentStatus:
    jobRecommendListForTrendEmploymentStatusState,
  jobRecommendListForTrendWelfareBenefits:
    jobRecommendListForTrendWelfareBenefitsInitialState,
  jobRecommendListForTrendLanguageAndPositions:
    jobRecommendListForTrendLanguageAndPositionsInitialState,
  jobRecommendListForTrendEstablish:
    jobRecommendListForTrendEstablishInitialState,
  precounseling: precounselingInitialState,
  ui: uiInitialState,
};

export const reducer = hydrateReducer(reducers, initialState);

export type RootState = ReturnType<typeof reducer>;
